import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link, Redirect } from 'react-router-dom';
import logo from './lo.png'
class Navbar extends Component {
  logOut(e) {
    e.preventDefault()
    localStorage.clear();
   // this.props.history.push(`/trail/login`)
    return   <Redirect to='http://pixelbyhand.com/user-login/' />
  }

  render() {
    const loginRegLink = (
      <ul className="navbar-nav">
       <li>
         <Link to="http://pixelbyhand.com/user-login/">Login</Link>
       </li>
    
      </ul>
    )

    return (
      <nav className="navbar navbar-expand-lg darker  spacing2">
       
        <div className="logo">
          <img src={logo} />
        </div>

        
      
        
       
    
      </nav>
    )
  }
}

export default Navbar;
